export default {
    //代理用户
    agency_key: '',
    mode:'',
    //用户中心的域名
    uc_host: 'https://i.kuaiyibo.cn',
    indexHost: 'https://www.kuaiyibo.cn',
    //专题页的域名
    special_url: '/',
    site_title: '集易欧—一手资源供应商',
    welcome_title: '集易欧—一手资源供应商！',
    site_short_title: '集易欧',
    site_subtitle: '一手资源供应商',
    beian: '鄂ICP备2020020739号-3',
    beian_gn: '',
    company_name: '武汉祥文网络科技有限公司',
    address: '武汉市洪山区现代光谷世贸中心B座13楼',
    copyright: '版权所有：武汉祥文网络科技有限公司 Copyright ©2015-2026 All Right Reserved',
    logo: require('./src/assets/brand/logo-aaga-light.png'),
    favicon:'/static/favicon.ico',
    agreement_signup:'https://www.kuaiyibo.cn/agreement.html',
    privacy_link:'https://www.kuaiyibo.cn/privacy.html',
    chat_url:'https://i.kuaiyibo.cn/signup',
    payment:'',
    qq: '2885262578',
    tel: '400-806-0925'
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 